import {Component, OnInit} from "@angular/core";
import * as L from "leaflet";
import {Monitoramento} from "../../domain/Monitoramento";
import {Jornada} from "../../domain/Jornada";
import {GpsService} from "../../services/gps.service";
import {Location} from "@capacitor-community/background-geolocation";
import {Especime} from "../../domain/Especime";
import {LineString} from "typeorm/browser";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss'],
})
export class TrackingComponent{
  map: L.Map;
  showHeader: false
  jornada: Jornada
  monitoramento: Monitoramento
  controlLayer: L.Control.Layers
  tracking : L.GeoJSON = L.geoJson()
  individuos: L.GeoJSON = L.geoJson()

  constructor(private gps: GpsService, private modalCtrl: ModalController ) {
    this.gps.addListener(this)
  }
  ionViewDidEnter() {
    console.log('criando mapa')
    this.leafletMap();
  }

  receberPonto(){
    this.updateTracking(this.gps.lineString)
  }

  leafletMap() {
    console.log('monitoramento ', this.monitoramento)
    console.log('jornada ', this.jornada)
    const padrao = this.getGoogleLayer(GoogleMaps.ROADMAP)
    const baseMaps = {
      "OpenStreetMap": L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '...' }),
      "Google RoadMap":  padrao,
      "Google Híbrido":  this.getGoogleLayer(GoogleMaps.HYBRID),
      "Google Satelite":  this.getGoogleLayer(GoogleMaps.SATELLITE),
      "Google Terra":  this.getGoogleLayer(GoogleMaps.TERRAIN),
    };
    const overlays = {
      "Tracking": this.tracking,
      "Indivíduos": this.individuos
    }
    this.map = L.map('mapId').setView([-19, -40], 5);
    padrao.addTo(this.map)
    this.controlLayer = L.control.layers(baseMaps, overlays).addTo(this.map);
    this.map.addLayer(this.tracking)
    this.map.addLayer(this.individuos)
    if(this.jornada) {
      this.updateTracking(this.gps.lineString)
      this.jornada?.monitoramentos?.forEach(m => {
        m.especimes?.forEach(e => {
          this.addIndividuos(e)
        })
      })
    } else {
      this.updateTracking(this.monitoramento.jornada.pontos)
      this.monitoramento.especimes?.forEach(e => {
          this.addIndividuos(e)
        })
    }
  }

  clearAll(){
    this.tracking.clearLayers()
    this.individuos.clearLayers()
  }

  updateTracking(lineString: LineString){
    if(lineString.coordinates.length >=2){
      this.tracking.clearLayers()
      this.tracking.addData(lineString)
      const bound = this.tracking.getBounds()//.extend(this.individuos.getBounds())
      try {
        this.map.fitBounds(bound)
      } catch (ex){
        console.error(ex)
        console.error(ex.stack)
      }
    }
  }



  addIndividuos(e: Especime){
    console.log('especime', e)
    const mark = L
      .marker({lat: e.ponto?.coordinates[1], lng: e.ponto?.coordinates[0]})
      .bindPopup(e?.taxon?.name)
    this.individuos.addLayer(mark)
    const bound = this.tracking.getBounds().extend(this.individuos.getBounds())
    console.log('bounds', bound)
    this.map.fitBounds(bound)
  }
  getGoogleLayer(letra: GoogleMaps | string) {
    return  L.tileLayer(`https://{s}.google.com/vt/lyrs=${letra}&x={x}&y={y}&z={z}`, {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    });
  }

  fechar(){
    this.modalCtrl.dismiss()
  }
}

export enum GoogleMaps{ROADMAP = "m", SATELLITE = "s", HYBRID = "s,h", TERRAIN = "p" }
